export const tableHeadDataUp = [
    {
        name: 'Head_1.name',
        rowspan: 'Head_1.rowspan',
        colspan: 'Head_1.colspan'
    },
    {
        name: 'Head_2.name',
        rowspan: 'Head_2.rowspan',
        colspan: 'Head_2.colspan'
    },
    {
        name: 'Head_3.name',
        rowspan: 'Head_3.rowspan',
        colspan: 'Head_3.colspan'
    }, 
    {
        name: 'Head_4.name',
        rowspan: 'Head_4.rowspan',
        colspan: 'Head_4.colspan'
    }
];
export const tableHeadDataDown = [
    {
        name: 'Head_5.name',
        rowspan: 'Head_5.rowspan',
        colspan: 'Head_5.colspan'
    }, 
    {
        name: 'Head_6.name',
        rowspan: 'Head_6.rowspan',
        colspan: 'Head_6.colspan'
    }, 
    {
        name: 'Head_7.name',
        rowspan: 'Head_7.rowspan',
        colspan: 'Head_7.colspan'
    }
    ];
